<template>
	<div>
		<div class="mb10">
			<el-button
				type="primary"
				size="small"
				class="table-toolbar-btn"
				@click="handleExport"
				v-if="perms.includes('home:repair:normalRepair:parts:export')">
				导出
			</el-button>
			<div class="search-wrapper">
				<span class="top-label">关键字</span>
				<el-input v-model="searchKey" size="small" placeholder="请输入关键字" @input="handleSearch"></el-input>
			</div>
			<div class="search-wrapper">
				<span class="top-label">流水号编号</span>
				<el-input v-model="serialNumber" size="small" placeholder="请输入流水号编号" @input="handleSearch"></el-input>
			</div>
		</div>
		<div>
			<el-table :data="dataList" :row-class-name="tableRowClassName" :header-cell-style="{ color: '#444' }" class="scroll-table" style="width: 100%">
				<el-table-column label="NO." width="60">
					<template slot-scope="scope">
						<span class="no">{{ scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column label="索赔编号" width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.mainInfo == null ? "暂无" : scope.row.mainInfo.serialNumber }}
					</template>
				</el-table-column>
				<el-table-column prop="partsName" label="零件名称" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="partsNumber" label="零件编号" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="partsAmount" label="零件数量" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="partsNumberNew" label="零件新编号" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="auditOrgName" label="索赔零件状态" width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ getClaimantRepairText(scope.row) }}
					</template>
				</el-table-column>
				<el-table-column prop="auditOrgName" label="测试结果" width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.partsTest == null ? "" : partsTests[scope.row.partsTest] }}
					</template>
				</el-table-column>
				<el-table-column prop="actualShippingTime" label="发货时间" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="mainInfo.claimShippingDuration" label="发货耗时" width="100" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.actualShippingTime ? scope.row.mainInfo.claimShippingDuration : "" }}
					</template>
				</el-table-column>
				<el-table-column prop="shippingUser" label="发货执行人" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="partsClaimExpress.sendAdvanceCode" label="发货CPI" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="partsClaimExpress.expressNumber" label="物流信息" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column label="索赔类型" width="200" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ getClaimantRepairTypeOptionsText(scope.row.mainInfo.repairType) }}
					</template>
				</el-table-column>
				<el-table-column prop="currentMainAudit.operNotes" label="索赔状态" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="mainInfo.repairDeviceName" label="机型及开发名" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="mainInfo.repairDeviceNumber" label="机号" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="mainInfo.applyOrgName" label="索赔发起方" width="150" show-overflow-tooltip></el-table-column>
			</el-table>
			<div class="pagination-wrapper pa25">
				<Pagination
					:page.sync="pageNo"
					:pageSize.sync="pageSize"
					:total="total"
					@sizeChange="handleSizeChange"
					@currentChange="handleCurrentChange"></Pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { claimPartsList, dataPartsExport } from "@/api/claim";
import Pagination from "@/components/Pagination";
import { claimantRepairTypeOptions } from "@/constant/options";
import { debounce } from "@/utils/debounce";
export default {
	components: {
		Pagination,
	},
	data() {
		return {
			// 权限
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			claimantRepairTypeOptions,
			pageNo: 1,
			pageSize: 10,
			total: 0,
			dataList: [],
			searchKey: "", // 关键字
			serialNumber: "", // 流水号编号
			partsTests: {
				1: "正常",
				2: "故障",
			},
		};
	},
	mounted() {
		// 获取索赔列表
		this.getPartsClaimList();
	},
	methods: {
		// 获取索赔类型名称
		getClaimantRepairTypeOptionsText(val) {
			for (const option of this.claimantRepairTypeOptions) {
				if (option.id === val) {
					return option.name;
				}
			}
		},
		// 获取索赔状态名称
		getClaimantRepairText(val) {
			if (val.currentAudit == null) {
				return val.currentMainAudit.operNotes;
			} else {
				return val.currentAudit.operNotes;
			}
		},
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		// 获取索赔列表
		getPartsClaimList() {
			let self = this;
			const params = {
				pageNo: self.pageNo,
				pageSize: self.pageSize,
				searchKey: self.searchKey,
				serialNumber: self.serialNumber,
			};
			claimPartsList(params, true)
				.then((r) => {
					if (r.code == "0") {
						self.dataList = r.data.list;
						self.total = r.data.totalCount;
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		handleSizeChange() {
			this.getPartsClaimList();
		},
		handleCurrentChange() {
			this.getPartsClaimList();
		},
		handleSearch: debounce(function () {
			this.pageNo = 1;
			this.getPartsClaimList();
		}, 1000),
		// 导出
		handleExport() {
			let self = this;
			const params = {
				searchKey: self.searchKey,
				serialNumber: self.serialNumber,
			};
			dataPartsExport(params, true)
				.then((r) => {
					if (r.code == "0") {
						const linkNode = document.createElement("a");
						linkNode.style.display = "none";
						linkNode.href = r.data;
						document.body.appendChild(linkNode);
						linkNode.click(); //模拟在按钮上的一次鼠标单击
						URL.revokeObjectURL(linkNode.href); // 释放URL 对象
						document.body.removeChild(linkNode);
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.ml10 {
	margin-left: 10px;
}
.top-label {
	margin: 0 10px;
	color: #606266;
	font-size: 14px;
}
.search-wrapper {
	display: inline-block;
	margin-left: 10px;
	margin-top: 10px;
	.el-select,
	.el-input {
		width: 200px;
	}
}
.pl55 {
	padding-left: 55px;
}
</style>
